import classNames from 'classnames';
import { FC, MouseEventHandler } from 'react';

import { IcBackgroundEffectIcon } from '@gem/icons';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import styles from './BlurButton.styles.m.css';

export interface IBlurButtonProps {
  className?: string;
  isDisabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  isBackgroundPanelShown: boolean;
}

export const BlurButton: FC<IBlurButtonProps> = ({
  className,
  isDisabled,
  onClick,
  isBackgroundPanelShown,
}) => {
  return (
    <IconButton
      className={classNames(styles.button, className)}
      Icon={IcBackgroundEffectIcon}
      size={IconViewSizes.Large}
      iconSize={IconViewSizes.Medium}
      iconClassName={styles.mainIcon}
      theme={isBackgroundPanelShown ? '13' : '12'}
      onClick={onClick}
      isDisabled={isDisabled}
    />
  );
};
